module.exports = __webpack_public_path__ + "static/media/robot_Idle.beb2fd4f.png";